import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import styles from '../styles/styles.js';
import buttonStyle from '../styles/buttonStyle.js';

const Alert = (props) => {
  const {
    isAlert,
    body,
    title,
    success,
    type,
    showConfirm,
    showCancel,
    customButtons,
    alertStyle,
    custom,
  } = props;

  const classes = useStyles();

  if (!isAlert) return null;

  const handleConfirm = () => props.onConfirm();
  const handleCancel = () => props.onCancel();

  return (
    <SweetAlert
      style={alertStyle}
      type={type}
      show={isAlert}
      success={success}
      title={title}
      style={{display: 'block'}}
      showCancel={ showCancel || showCancel === false ? showCancel : true}
      showConfirm={ showConfirm || showConfirm === false ? showConfirm : true}
      /* accessibility issue; button is uncustomizable */
      showCloseButton={false}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      confirmBtnCssClass={
        classes.button + ' ' + classes.success
      }
      custom={custom || false}
      customButtons={customButtons}>
      <div className={classes.alert}>
        { body }
      </div>
    </SweetAlert>
  );
};

Alert.defaultProps = {
  isAlert: false,
  title: '',
  body: '',
  type: 'default',
  onConfirm: () => null,
  onCancel: () => null,
};

Alert.propTypes = {
  showCancel: PropTypes.bool,
  showConfirm: PropTypes.bool,
  isAlert: PropTypes.bool.isRequired,
  body: PropTypes.node,
  title: PropTypes.node.isRequired,
  success: PropTypes.bool,
  type: PropTypes.oneOf([
    'default', 'secondary', 'info', 'success', 'warning',
    'danger', 'error', 'input', 'custom', 'controlled',
  ]).isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  customButtons: PropTypes.node,
  alertStyle: PropTypes.object,
  custom: PropTypes.bool,
};

const useStyles = styles.makeStyles(
    () => ({
      ...buttonStyle,
    }),
);

export default Alert;

